$( document ).ready(function() {
    
    var alphabeticallyOrderedDivs = $('.state-item').sort(function(a, b) {
        return String.prototype.localeCompare.call($(a).data('location-filter').toLowerCase(), $(b).data('location-filter').toLowerCase());
    });
    var locationscontainer = $(".location-filter-options");
    locationscontainer.detach().empty().append(alphabeticallyOrderedDivs);
    
    $('.location-filter-options-outer').append(locationscontainer);
    
    $('.location-filter').click(function() {
        $(this).toggleClass('opened');
    });

    $( ".location-filter-options-outer" ).on( "click", "[data-location-filter]:not(.selected-location)", function() {
        $('[data-location-filter]').removeClass('selected-location');
        $(this).addClass('selected-location');
        $('.location-filter-select span').html($(this).data('location-filter'));
        if($(this).data('location-filter') == 'All States') {
            $(`.sauna-location`).fadeOut(500);
            setTimeout(() => {
                $(`[data-state]`).fadeIn(500);
              }, "450");
        }
        else {
            $(`.sauna-location`).fadeOut(500);
            setTimeout(() => {
                $(`[data-state="${$(this).data('location-filter')}"]`).fadeIn(500);
              }, "450");
        }
    });
});
